<template>
  <div>
    <v-data-table
      fixed-header
      :height="tableHeight"
      style="background: #a9a9a93d"
      :items="data"
      :options.sync="options"
      :headers="officeListHeaders"
      :loading="tableLoading"
      :footer-props="footerProps"
      :server-items-length="getPaginator.total"
      class="elevation-1"
    >
      <template v-slot:top>
        <v-toolbar
          flat
        >
          <v-btn
            color="success"
            rounded
            outlined
          >
            {{ `${getTotalAmount} ₽` }}
          </v-btn>
          <v-divider
            class="mx-4"
            inset
            vertical
          />
          <v-btn
            color="secondary"
            rounded
            outlined
          >
            {{ `${getTotalOffers} Оф.` }}
          </v-btn>
          <v-divider
            class="mx-4"
            inset
            vertical
          />
          <v-spacer />
          <v-btn
            color="primary"
            icon
            @click="enableListFilterEnabled"
          >
            <v-icon
              v-if="!listFilterEnabled"
              large
            >
              mdi-filter-variant
            </v-icon>
            <v-icon v-else>
              mdi-close
            </v-icon>
          </v-btn>
          <v-btn
            color="success"
            class="mx-1"
            outlined
            rounded
            small
            @click="enableImportModalEnabled"
          >
            Импортировать
          </v-btn>
          <v-dialog
            v-model="officeDialog"
            max-width="540px"
            persistent
          >
            <template v-slot:activator="{ on, attrs }">
              <v-btn
                color="success"
                class="mx-1"
                v-bind="attrs"
                outlined
                rounded
                small
                v-on="on"
              >
                Добавить
              </v-btn>
            </template>
            <v-card>
              <v-card-title>
                <span class="headline">{{ formTitle }}</span>
              </v-card-title>

              <v-card-text>
                <v-container>
                  <v-row>
                    <v-col
                      cols="12"
                      :sm="12"
                      class="py-0 my-0 mb-2"
                    >
                      <v-text-field
                        v-model="currentOffice.title"
                        outlined
                        label="Название"
                        :error-messages="formErrors('title')"
                        required
                        hide-details
                        @change="$v.currentOffice.title.$touch()"
                        @blur="$v.currentOffice.title.$touch()"
                      />
                    </v-col>
                    <v-col
                      cols="12"
                      :sm="12"
                      class="py-0 my-0 mb-2"
                    >
                      <WBDAutocompleteSearch
                        :model-type="modelTypeSet.MODEL_TYPE_ADDRESS"
                        :value="getAddressSearchValue"
                        :item-value="'id'"
                        :item-text="'fullAddress'"
                        :error="addressError"
                        hide-details
                        sync
                        :label="'Поиск по полному адресу включая номер дома'"
                        :placeholder="'Поиск по полному адресу включая номер дома'"
                        @wbdAutoCompleteSelected="onAddressChange"
                      />
                    </v-col>
                    <v-col
                      cols="12"
                      :sm="12"
                      class="py-0 my-0 mb-2"
                    >
                      <v-text-field
                        v-model="currentOffice.externalCode"
                        outlined
                        label="Код завода"
                        required
                        hide-details
                      />
                    </v-col>
                    <v-col
                      cols="12"
                      :sm="12"
                      class="py-0 my-0 mb-2"
                    >
                      <v-textarea
                        v-model="currentOffice.route"
                        outlined
                        required
                        hide-details
                      >
                        <template v-slot:label>
                          <div>
                            Схема прохода
                          </div>
                        </template>
                      </v-textarea>
                    </v-col>
                    <v-col
                      cols="12"
                      :sm="12"
                      class="py-0 my-0 mb-2"
                    >
                      <v-select
                        v-model="currentOffice.weatherCondition"
                        :items="weatherConditionList"
                        label="Температурный режим на объекте"
                        :item-text="'title'"
                        :item-value="'id'"
                        return-object
                        :error-messages="formErrors('weatherCondition')"
                        required
                        hide-details
                        @change="$v.currentOffice.weatherCondition.$touch()"
                        @blur="$v.currentOffice.weatherCondition.$touch()"
                      />
                    </v-col>
                    <v-col
                      cols="12"
                      :sm="12"
                      class="py-0 my-0 mb-2"
                    >
                      <v-checkbox
                        v-model="currentOffice.hasTransportation"
                        outlined
                        label="Корпоративный транспорт"
                        hide-details
                      />
                    </v-col>
                  </v-row>
                </v-container>
              </v-card-text>

              <v-card-actions>
                <v-spacer />
                <v-btn
                  color="blue darken-1"
                  text
                  @click="close"
                >
                  Отменить
                </v-btn>
                <v-btn
                  color="success"
                  outlined
                  rounded
                  @click="save"
                >
                  сохранить
                </v-btn>
              </v-card-actions>
            </v-card>
          </v-dialog>
          <v-dialog
            v-model="dialogDelete"
            max-width="500px"
          >
            <v-card>
              <v-card-title class="headline">
                Удалить этот объект?
              </v-card-title>
              <v-card-actions>
                <v-spacer />
                <v-btn
                  color="blue darken-1"
                  text
                  @click="closeDelete"
                >
                  Нет
                </v-btn>
                <v-btn
                  color="blue darken-1"
                  text
                  @click="deleteItemConfirm"
                >
                  Да
                </v-btn>
                <v-spacer />
              </v-card-actions>
            </v-card>
          </v-dialog>
        </v-toolbar>
        <v-card
          v-if="listFilterEnabled"
          class="mt-2"
        >
          <v-card-text>
            <WBDOfficeListFilter
              :office-list-filter-set.sync="officeListFilterSet"
            />
          </v-card-text>
          <v-card-actions>
            <v-spacer />
            <v-btn
              v-if="getActiveFilterNumber"
              class="mr-1"
              text
              color="warning"
              @click="resetFilterSet"
            >
              Очистить
            </v-btn>
            <v-btn
              rounded
              color="success"
              @click="requestOfficeList"
            >
              Поиск
            </v-btn>
          </v-card-actions>
        </v-card>
      </template>
      <template v-slot:item.managerList="{ item }">
        {{ item.managerList? item.managerList.length: null }}
      </template>
      <template v-slot:item.externalCode="{ item }">
        <span>{{ item.externalCode }}</span>
        <span v-if="item.storeId"> / {{ item.storeId }}</span>
      </template>
      <template v-slot:item.supportNumber="{ item }">
        <ItemLinkView
          :label="undefined"
          :value="getViewRouteData(item)"
          :link-text="`${item.supportNumber || ' '}`"
        />
      </template>
      <template v-slot:item.rawRegion="{ item }">
        <span v-if="item.rawRegion">
          <span v-if="item.rawRegion && item.rawRegion.code"> {{ ` [${item.rawRegion.code}]` }}</span>
          {{ item.rawRegion.title }}
        </span>
      </template>
      <template v-slot:item.transportation="{ item }">
        {{ item.transportation.id ? 'Да' : 'Нет' }}
      </template>
      <template v-slot:item.isActive="{ item }">
        {{ item.status === 'active' ? 'Да' : 'Нет' }}
      </template>
      <template v-slot:item.options="{ item }">
        <div style="display: flex; flex-direction: row; justify-content: space-between">
          <!--          <v-btn-->
          <!--            icon-->
          <!--            small-->
          <!--            @click="rowClicked(item)"-->
          <!--          >-->
          <!--            <v-icon small>-->
          <!--              fa-eye-->
          <!--            </v-icon>-->
          <!--          </v-btn>-->
          <v-icon
            small
            class="mr-2"
            @click="editItem(item)"
          >
            mdi-pencil
          </v-icon>
          <v-icon
            small
            class="mr-2"
            @click="gotoOfficeViewPage(item.id)"
          >
            mdi-arrow-right
          </v-icon>
        </div>
      </template>
    </v-data-table>
    <OfficeView
      v-show="canView"
      :data="offerList"
      :office="current"
      :tableLoading="viewLoading"
      :display.sync="canView"
    />
    <OfficeImportComponentDialog
      v-if="importModalEnabled && (organization && organization.id)"
      :enabled="importModalEnabled"
      :organization="organization"
      action="organization/importOffice"
      @onCloseOfficeImportDialog="disableImportModalEnabled"
    />
  </div>
</template>
<script>
import OfficeView from '@/views/organization/office-view'
import OfficeImportComponentDialog from '@/views/organization/office-import-dialog'
import ListMixin from '@/mixins/list-mixin.vue'
import { validationMixin } from 'vuelidate'
import { required } from 'vuelidate/lib/validators'
import WBDOfficeListFilter from '@/components/common/filter/office-list-filter'
import OfficeListUtil from '@/utils/office-list-filter-util'
import WBDAutocompleteSearch from '@/components/common/autocomplete/index'
import NavigationMixin from '@/mixins/navigation-mixin'
import ItemLinkView from '@/views/offer/itemLinkView'
import { OFFICE_VIEW_ROUTE_NAME } from '@/router/client'

export default {
  name: 'OrganizationOfficeTabComponent',
  components: {
    OfficeImportComponentDialog,
    OfficeView,
    WBDOfficeListFilter,
    WBDAutocompleteSearch,
    ItemLinkView
  },
  mixins: [NavigationMixin, ListMixin, validationMixin],
  validations: {
    currentOffice: {
      title: { required },
      address: { required },
      weatherCondition: { required },
    }
  },
  props: {
    tableLoading: {
      type: Boolean
    },
    officeOptions: {
      type: Object
    },
    organization: {
      type: Object
    },
    data: {
      type: Array
    },
  },
  data: () => ({
    importModalEnabled: false,
    addressError: false,
    listFilterEnabled: false,
    officeListFilterSet: {
      city: undefined,
      region: undefined,
      status: undefined,
      type: undefined,
      searchQuery: '',
    },
    canView: false,
    offerList: [],
    current: {},
    options: {},
    viewLoading: false,
    list: [],
    officeListHeaders: [],
    //
    // weatherConditionList: [
    //   { label: 'Нормальный', value: 'normal', name: 'temperature' },
    //   { label: 'Холодный', value: 'cold', name: 'temperature' }
    // ],
    officeDialog: false,
    dialogDelete: false,
    currentOffice: {
      id: '',
      title: '',
      address: '',
      hasTransportation: false,
      weatherCondition: null,
      route: null,
      externalCode: null,
    },
    defaultOffice: {
      id: '',
      title: '',
      address: '',
      hasTransportation: false,
      weatherCondition: null,
      route: null,
      externalCode: null,
    },
    weatherConditionList: []
  }),
  computed: {
    isValid () {
      return true
    },
    getAddressSearchValue () {
      if (!this.currentOffice.address) {
        return undefined
      }

      return {
        id: 'office-id',
        title: this.currentOffice.address,
      }
    },
    getActiveFilterNumber () {
      return OfficeListUtil.getActiveFilterNumber(this.officeListFilterSet)
    },
    getPaginator () {
      return this.$store.getters['office/getPaginator']
    },
    getTotalOffers () {
      let total = 0
      if (this.data && this.data.length) {
        for (const office of this.data) {
          total += parseFloat(office.availableOffersNumber)
        }
      }

      return new Intl.NumberFormat().format(total)
    },
    getTotalAmount () {
      let total = 0
      if (this.data && this.data.length) {
        for (const office of this.data) {
          total += parseFloat(office.amount)
        }
      }

      return new Intl.NumberFormat().format(total)
    },
    getOfficeList () {
      return this.$store.state.organization.officeList || []
    },
    formTitle () {
      return `${!this.currentOffice.id ? 'Добавление' : 'редактирование'} объекта`
    },
  },
  watch: {
    officeDialog (val) {
      val || this.close()
    },
    dialogDelete (val) {
      val || this.closeDelete()
    },
    options: {
      handler (val) {
        this.$emit('onOfficeOptionChange', val)
        // this.requestList(this.options.page, this.options.itemsPerPage)
      },
      deep: true,
    },
  },
  created () {
    this.officeListHeaders = OfficeListUtil.officeListHeader
    this.options = { ...this.officeOptions }
    this.requestWeatherConditionList()
  },
  methods: {
    requestWeatherConditionList () {
      this.$store.dispatch('organization/getWeatherConditionList')
        .then((response) => {
          const list = response.data

          if (list && list.length) {
            const mapper = {
              'cold': 'Холодный',
              'normal': 'Нормальный',
            }

            this.weatherConditionList = list.map((item) => ({ ...item, title: mapper[item.title] || item.title }))
          }
        })
    },
    async rowClicked (item) {
      this.offerList = []
      this.canView = true
      this.current = item

      this.viewLoading = true
      const list = await this.$store.dispatch(
        'organization/getOfficeOffersList',
        { id: item.id }
      )
      this.viewLoading = false
      this.offerList = list.data
      this.$forceUpdate()
    },

    editItem (item) {
      this.currentOffice = {
        id: item.id,
        title: item.title,
        address: item.address,
        hasTransportation: item.hasTransportation,
        weatherCondition: item.weatherCondition,
        route: item.route ? item.route.description : '',
        externalCode: item.externalCode
      }
      this.officeDialog = true
    },

    deleteItem (item) {
      // this.editedIndex = this.desserts.indexOf(item)
      // this.currentOffice = Object.assign({}, item)
      this.dialogDelete = true
    },

    deleteItemConfirm () {
      this.desserts.splice(this.editedIndex, 1)
      this.closeDelete()
    },

    close () {
      this.officeDialog = false
      this.$nextTick(() => {
        this.currentOffice = Object.assign({}, this.defaultOffice)
      })
    },

    closeDelete () {
      this.dialogDelete = false
      this.$nextTick(() => {
        this.currentOffice = Object.assign({}, this.defaultOffice)
        this.editedIndex = -1
      })
    },

    async save () {
      this.$v.$touch()
      if (!this.currentOffice.address) {
        this.addressError = true
      }
      if (this.$v.$invalid || this.addressError) {
        return false
      }
      const model = {
        ...this.currentOffice,
        'address': this.currentOffice.address.id,
        'organization': { 'id': this.$route.params.id },
        'route': { 'description': this.currentOffice.route || '' },
      }

      this.showPageLoader()
      const method = model.id ? 'updateOffice' : 'createOffice'

      this.$store.dispatch(
        `organization/${method}`,
        model
      ).then((response) => {
        if (response.data && response.data.id) {
          this.gotoOfficeViewPage(response.data.id)
        }
        this.$emit('reloadOfficeList')
        this.close()
        this.showSuccessNotification('Объект успешно создан')
        this.hidePageLoader()
      }).catch((error) => {
        this.hidePageLoader()
        console.log(error)
        this.showErrorNotification('Ошибка при создании объекта')
      })
    },
    formErrors (field) {
      const errors = []
      const taskField = this.$v.currentOffice[field]
      if (!taskField.$dirty) return errors
      !taskField.required && errors.push('поле обязательно для заполнения.')
      return errors
    },
    async resetFilterSet () {
      this.officeListFilterSet = {
        organization: undefined,
        region: undefined,
        city: undefined,
        status: undefined,
        type: undefined,
        searchQuery: '',
      }

      this.$forceUpdate()

      this.eventsBus.$emit(this.eventNames.OFFICE_LIST_FILTER_RESET)

      this.requestOfficeList()
    },
    async enableListFilterEnabled () {
      this.listFilterEnabled = !this.listFilterEnabled
    },
    requestOfficeList () {
      this.$emit('onFilterBtnClicked', this.officeListFilterSet)
    },
    onAddressChange (data) {
      this.currentOffice.address = data
    },
    enableImportModalEnabled () {
      this.importModalEnabled = true
    },
    async disableImportModalEnabled (saved) {
      this.importModalEnabled = false
      if (saved) {
        await this.requestOfficeList()
      }
    },
    getViewRouteData (item) {
      return this.$router.resolve(
        {
          name: OFFICE_VIEW_ROUTE_NAME,
          params: { id: item.id }
        }
      ).href
    },
  }
}
</script>
